import { version } from '../package.json'

const DASHBOARD_RECENT_FETCH_MS = 1000

let inflightGetDashboard = null
let lastSuccessfulDashboardFetchAt = 0

const state = () => ({
  group: null,
  patient: null,
  appointment: null,
  exams: null,
  shopLink: null,
  license: null,
  annotations: null,
})
const getters = {
  group: (state) => state.group,
  patient: (state) => state.patient,
  appointment: (state) => state.appointment,
  exams: (state) => state.exams,
  shopLink: (state) => state.shopLink,
  license: (state) => state.license,
  annotations: (state) => state.annotations,
}
const mutations = {
  receiveGroup(state, group) {
    state.group = group
  },
  receivePatient(state, patient) {
    state.patient = patient
  },
  receiveAppointment(state, appointment) {
    state.appointment = appointment
  },
  receiveExams(state, exams) {
    state.exams = exams
  },
  receiveShopLink(state, shopLink) {
    state.shopLink = shopLink
  },
  receiveLicense(state, license) {
    state.license = license
  },
  receiveAnnotations(state, annotations) {
    state.annotations = annotations
  },
}
const actions = {
  getDashboard({ commit, rootState, rootGetters }, { force = false } = {}) {
    if (!force && inflightGetDashboard) {
      return inflightGetDashboard
    }

    if (
      !force &&
      lastSuccessfulDashboardFetchAt &&
      Date.now() - lastSuccessfulDashboardFetchAt < DASHBOARD_RECENT_FETCH_MS
    ) {
      return Promise.resolve()
    }

    const versionUpdatedToday = rootGetters['user/versionUpdatedToday']
    const request = this.$axios
      .post('/bodygram-backend/v1/core/home/index', {
        accessToken: rootState.user.token,
        version,
        appType: process.env.appType,
        versionUpdated: versionUpdatedToday,
      })
      .then((response) => {
        lastSuccessfulDashboardFetchAt = Date.now()
        commit('receiveGroup', response.data.recent.group)
        commit('receivePatient', response.data.recent.patient)
        commit('receiveAppointment', response.data.appointment)
        commit('receiveExams', response.data.exams)
        commit('receiveShopLink', response.data.shopLink)
        commit('receiveLicense', response.data.license)
        commit('receiveAnnotations', response.data.annotations)

        if (!versionUpdatedToday) {
          commit('user/setVersionUpdates', null, { root: true })
        }
      })
      .finally(() => {
        if (inflightGetDashboard === request) {
          inflightGetDashboard = null
        }
      })

    inflightGetDashboard = request
    return request
  },
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
